import { createSlice } from '@reduxjs/toolkit';
import { deriveIndicador } from '../utils/deriveIndicador';
import { fetchUltimasConversas } from './actions';
import type { UltimasConversasState, ItemUltimaConversa } from '@/types/homeConversas/types';

const initialState: UltimasConversasState = {
  items: [],
  loading: false,
  error: null,
  hasFetched: false,
};

const homeConversasSlice = createSlice({
  name: 'home-conversas',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUltimasConversas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUltimasConversas.fulfilled, (state, action) => {
        state.loading = false;
        state.hasFetched = true;
        state.items = action.payload.items.map(
          (item): ItemUltimaConversa => ({
            ...item,
            indicador: deriveIndicador({
              status: item.status,
              direction: item.ultimaMensagem.direction,
            }),
          }),
        );
      })
      .addCase(fetchUltimasConversas.rejected, (state, action) => {
        state.loading = false;
        state.hasFetched = true;
        state.error = action.error.message ?? 'Erro desconhecido';
      });
  },
});

export default homeConversasSlice.reducer;
